"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.routes = void 0;
var urlcat_1 = __importDefault(require("urlcat"));
function createRouteURL(path) {
    return function (params, basePath) { return "" + (basePath !== null && basePath !== void 0 ? basePath : '') + urlcat_1.default(path, params !== null && params !== void 0 ? params : {}); };
}
function route(path) {
    return {
        path: path,
        getUrl: createRouteURL(path),
    };
}
exports.routes = {
    create: route('/create'),
    updateDisplayName: route('/:id/update-display-name'),
    getSavedAddressByAccountUuid: route('/saved-addresses/account/:id'),
};
